/**
 * KAN-980 / KAN-979: раздел "Платформа" (только суперпользователь): кабинеты
 * с ручной корректировкой кошелька, пул Telegram-аккаунтов и цены платформы
 * (KAN-1000: курс доллара и наценки).
 */
import { PageLayout } from '@/components/layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CabinetsTab } from '@/components/platform/CabinetsTab';
import { TgPoolTab } from '@/components/platform/TgPoolTab';
import { PricingTab } from '@/components/platform/PricingTab';

export function PlatformPage() {
  return (
    <PageLayout title="Платформа">
      <Tabs defaultValue="cabinets">
        <TabsList>
          <TabsTrigger value="cabinets">Кабинеты</TabsTrigger>
          <TabsTrigger value="tg-pool">Пул Telegram</TabsTrigger>
          <TabsTrigger value="pricing">Цены</TabsTrigger>
        </TabsList>
        <TabsContent value="cabinets">
          <CabinetsTab />
        </TabsContent>
        <TabsContent value="tg-pool">
          <TgPoolTab />
        </TabsContent>
        <TabsContent value="pricing">
          <PricingTab />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
}
